import { __decorate, __extends } from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import StoreLoadingBar from '../Stores/Tools/StoreLoadingBar';
var LoadingBarControl = /** @class */ (function (_super) {
    __extends(LoadingBarControl, _super);
    /**
     * Class constructor
     * @param {any} props Constructor props
     */
    function LoadingBarControl(props) {
        return _super.call(this, props) || this;
    }
    /**Handle component did mount event */
    LoadingBarControl.prototype.componentDidMount = function () {
        StoreLoadingBar.Show();
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     * */
    LoadingBarControl.prototype.render = function () {
        return (React.createElement("div", { className: 'react-top-loading-bar' },
            React.createElement("div", { className: "loading-bar " + StoreLoadingBar.DisplayClass, style: {
                    width: StoreLoadingBar.Progress.toString() + '%'
                } })));
    };
    LoadingBarControl = __decorate([
        observer
    ], LoadingBarControl);
    return LoadingBarControl;
}(React.Component));
export { LoadingBarControl };
//# sourceMappingURL=LoadingBarControl.js.map